module.exports = __webpack_public_path__ + "static/5-266791875a993eee5fe2c2d4317ac52b.png";